<template>
  <div class="container">
    <!--搜索-->
    <search-filter :form-config="searchConfig" :model="query" @search="search" @reset="reset"></search-filter>
    <!--列表-->
    <el-table v-loading="loading" :data="tableData"  stripe border 
      style="width: 100%">
      <el-table-column border label="序号" prop="id"></el-table-column>
      <el-table-column border label="场所类型" prop="site_type"></el-table-column>
      <el-table-column border label="CMA类型" prop="cma_type"></el-table-column>
      <el-table-column border label="隐患" prop="trouble"></el-table-column>
      <el-table-column border label="隐患等级" prop="level"></el-table-column>
      <el-table-column border label="整改建议" prop="answer"></el-table-column>
      <el-table-column border label="隐患描述" prop="trouble_desc"></el-table-column>
      <el-table-column border label="接地系统" prop="jdxt"></el-table-column>
      <el-table-column border label="β值" prop="beta"></el-table-column>
      <el-table-column border label="备注" prop="beta"></el-table-column>
      <!-- <el-table-column border label="操作" min-width="120" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!--分页-->
    <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
      :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    <!--对话框-->
    <el-dialog title="新增人员" :visible.sync="addModel.addShow" width="600px">
      <el-form ref="addForm" :model="addModel" label-width="80px" size="small">
        <el-form-item label="人员名称">
          <el-input v-model="addModel.employee_name" placeholder="人员名称"></el-input>
        </el-form-item>
        <el-form-item label="登录账号">
          <el-input v-model="addModel.account" placeholder="登录账号"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="addModel.password" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="addModel.mobile" placeholder="联系方式"></el-input>
        </el-form-item>
        <el-form-item label="是否有效">
          <el-switch v-model="addModel.valid"></el-switch>
        </el-form-item>
        <el-form-item style="margin-left:80px;margin-top: 30px">
          <el-button type="primary" @click="onAdd">新增</el-button>
          <el-button type="info" @click="onAddClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="编辑人员" :visible.sync="editModel.editShow" width="600px">
      <el-form ref="editForm" :model="editModel" label-width="80px" size="small">
        <el-form-item label="人员ID">
          <el-input v-model="editModel.id" disabled></el-input>
        </el-form-item>
        <el-form-item label="人员名称">
          <el-input v-model="editModel.employee_name" placeholder="人员名称"></el-input>
        </el-form-item>
        <el-form-item label="登录账号">
          <el-input v-model="editModel.account"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="editModel.password" placeholder="修改密码请写新密码，不修改密码则留空"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="editModel.mobile"></el-input>
        </el-form-item>
        <el-form-item label="是否有效">
          <el-switch v-model="editModel.valid"></el-switch>
        </el-form-item>
        <el-form-item style="margin-left:80px;margin-top: 30px">
          <el-button type="primary" @click="onEdit">编辑</el-button>
          <el-button type="info" @click="onEditClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      currentConfig: {},
      tableData: [],
      pagination: { current_page: 1, total: 1, per_page: 10, },
      query: { employee_name2: "", account: "", mobile: "" },
      searchConfig: [
        {
          key: "site_type", label: "场所类型", type: "select", list: [
            { text: '出租屋', value: 'czw' },
            { text: '三小场所', value: 'sx' },
            { text: '其他场所', value: 'other' },
          ]
        },
        {
          key: "cma_type", label: "CMA类型", type: "select", list: [
            { text: '电气系统的带电设备红外诊断', value: '电气系统的带电设备红外诊断' },
            { text: '电气系统的剩余电流保护装置特性', value: '电气系统的剩余电流保护装置特性' },
            { text: '电气系统的距离', value: '电气系统的距离' },
            { text: '电气系统的绝缘电阻', value: '电气系统的绝缘电阻' },
            { text: '电气系统的接地电阻', value: '电气系统的接地电阻' },
          ]
        },
        { key: "trouble", label: "隐患", type: "input" },
        {
          key: "level", label: "隐患等级", type: "select", list: [
            { text: 'A', value: 'A' },
            { text: 'B', value: 'B' },
            { text: 'C', value: 'C' }
          ]
        },
        { key: "answer", label: "整改建议", type: "input" },
        { key: "trouble_desc", label: "隐患描述", type: "input" },
        {
          key: "jdxt", label: "接地系统", type: "select", list: [
            { text: 'TT系统', value: 'TT系统' },
            { text: 'TN-C-S系统', value: 'TN-C-S系统' },
            { text: 'TN-S系统', value: 'TN-S系统' },
            { text: 'TN-C系统', value: 'TN-C系统' }
          ]
        },
      ],
      addModel: {
        addShow: false,
        employee_name: '',
        account: '',
        password: '12345678',
        mobile: '',
        valid: true
      },
      editModel: {
        editShow: false,
        id: '',
        employee_name: '',
        account: '',
        password: '12345678',
        mobile: '',
        valid: true
      },
    };
  },
  computed: {
    ...mapGetters(['hasPermission']),
  },
  methods: {
 
    //新增
    handleAdd() {
      this.addModel.addShow = true
    },
    async onAdd() {
      try {
        let params = {
          new_employee_name: this.addModel.employee_name,
          account: this.addModel.account,
          password: this.addModel.password,
          mobile: this.addModel.mobile,
          valid: this.addModel.valid ? 1 : 0
        }
        await this.$Api.post('sys_employee', params)
        this.$message.success('新增成功')
        this.initModel('add')
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onAddClose() {
      this.initModel('add')
    },
    //编辑
    handleEdit(row) {
      this.editModel.editShow = true
      this.editModel.id = row.id
      this.editModel.employee_name = row.employee_name
      this.editModel.account = row.account
      this.editModel.mobile = row.mobile
      this.editModel.valid = row.valid
    },
    async onEdit() {
      try {
        let params = {
          id: this.editModel.id,
          employee_name2: this.editModel.employee_name,
          account: this.editModel.account,
          password: this.editModel.password,
          mobile: this.editModel.mobile,
          valid: this.editModel.valid
        }
        await this.$Api.post('sys_employee_edit', params)
        this.$message.success('编辑成功')
        this.initModel('edit')
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onEditClose() {
      this.initModel('edit')
    },
    changePage() {
      this.getList();
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    search() {
      this.getList();
    },
    reset() {
      this.query = {
        employee_name2: "",
        account: "",
        mobile: "",
      };
      this.pagination.current_page = 1;
      this.pagination.total = 1;
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        let params = {
          ...this.query,
          ...this.pagination,
        };
        let data = await this.$Api.get("cma_troubles", { params: params });

        this.pagination = {
          current_page: data.current_page,
          total: data.total,
          per_page: data.per_page
        }
        this.tableData = data.data;
        this.loading = false;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>
